var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-title',[_vm._v(_vm._s(_vm.title))]),(_vm.description)?_c('v-card-subtitle',{domProps:{"innerHTML":_vm._s(_vm.description)}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }